import React from 'react'
import "../styles/loader.scss"

const Loader = () => {
  return (
    <div className="loader"></div>
  )
}

export default Loader